import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { METHODOLOGY_EXPLAINER_PAGE_PRECIPITATION_INDICATORS } from '@/config/constants';

import {
  Explainer,
  ExplainerBody,
  ExplainerContent,
  ExplainerCopy,
  ExplainerTitle,
  ExplainerTrigger,
  MethodologyLink,
} from './Explainer';

export const PrecipitationExplainer = () => {
  const { t } = useTranslation();

  return (
    <Explainer>
      <ExplainerTrigger data-testid='precipitation-explainer'>
        {t('shared.ncaDetail.details.labels.howDoWeMeasureThis')}
      </ExplainerTrigger>
      <ExplainerContent>
        <ExplainerTitle>
          {t('shared.ncaDetail.details.water.explainers.howDoMeasureThis.precipitation.headline')}
        </ExplainerTitle>
        <Stack className='items-start pb-6'>
          <ExplainerBody>
            <ExplainerCopy
              title={t('shared.ncaDetail.details.water.explainers.howDoMeasureThis.precipitation.title')}
              body={t('shared.ncaDetail.details.water.explainers.howDoMeasureThis.precipitation.body')}
            />
          </ExplainerBody>
          <MethodologyLink to={METHODOLOGY_EXPLAINER_PAGE_PRECIPITATION_INDICATORS} />
        </Stack>
      </ExplainerContent>
    </Explainer>
  );
};
